const hideZeroPriceColors = (product_json, price_json) => {
  const colorVariantIds = {};
  const colorPriceTotals = {};

  const nonZeroSizes = product_json.variants.filter((variant) => variant.price > 0).map((variant) => variant.option2);

  const zeroPriceVariants = product_json.variants.filter((variant) => variant.price === 0);

  for (let i = 0; i < product_json.variants.length; i++) {
    const item = product_json.variants[i];

    if (colorVariantIds[item.option1]) {
      colorVariantIds[item.option1].push(item.id);
    } else {
      colorVariantIds[item.option1] = [item.id];
    }
  }

  const colors = Object.keys(colorVariantIds);

  for (let i = 0; i < colors.length; i++) {
    const color = colors[i];

    const sum = colorVariantIds[color].reduce((acc, val) => {
      return acc + parseInt(price_json[val], 10);
    }, 0);

    colorPriceTotals[color] = sum;
  }

  for (let i = 0; i < colors.length; i++) {
    const color = colors[i];

    if (colorPriceTotals[color] === 0) {
      document
        .querySelectorAll(`[data-color-variant-selector][data-value="${color}"]`)
        .forEach((el) => (el.style.display = 'none'));
      document
        .querySelectorAll(`[data-secondary-color-variant-selector][data-value="${color}"]`)
        .forEach((el) => (el.style.display = 'none'));
    }
  }

  // Remove the sizes that only have zero prices
  zeroPriceVariants.forEach((variant) => {
    if (nonZeroSizes.includes(variant.option2)) {
      return;
    }

    document
      .querySelectorAll(`[data-size-variant-selector][data-value="${variant.option2}"]`)
      .forEach((el) => (el.style.display = 'none'));
    document
      .querySelectorAll(`[data-secondary-size-variant-selector][data-value="${variant.option2}"]`)
      .forEach((el) => (el.style.display = 'none'));
    document
      .querySelectorAll(`select[data-size-variant-selector] option[value="${variant.option2}"]`)
      .forEach((el) => (el.disabled = true));
  });

  setTimeout(() => {
    const selectElements = document.querySelectorAll('select[data-size-variant-selector]');
    selectElements.forEach((select) => {
      const event = new Event('change');
      select.dispatchEvent(event);
    });
  }, 1);
};

export default hideZeroPriceColors;
